import { __assign as o } from "./_virtual/_tslib.js";
import r from "react";
import { useBindProp as t } from "./hooks/props.js";
import { getInitialOptionsFromProps as i } from "./utils/options.js";
import m from "./hooks/component.js";
import s from "./hooks/common/visible.js";
import e from "./hooks/common/z-index.js";
import n from "./hooks/common/opacity.js";
import l from "./hooks/common/zooms.js";
var p = r.createContext(void 0);
export default function (a) {
  var c = m({
    init: function init(r) {
      var t = o({}, i(a));
      return new r.LabelsLayer(t);
    }
  }, a);
  return s(c, a), e(c, a), n(c, a), l(c, a), t(c, {
    setter: "setCollision"
  }, a.collision), t(c, {
    setter: "setAllowCollision"
  }, a.allowCollision), r.createElement(p.Provider, {
    value: c
  }, c && a.children);
}
export { p as LabelsLayerContext };